import React from 'react';
import { bonuses } from '../data/content';
import { BonusCover } from './BonusCover';
import { SectionHeading } from './SectionHeading';

// 3 + 2 centered layout on desktop
const placement = ['', '', '', 'lg:col-start-2', ''];
export function Bonuses() {
  return <section aria-labelledby="bonuses-title" className="bg-cream" data-id="element-22" data-mp="at8uo6i86ra9">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-23" data-mp="fslgqp19vubs">
        <SectionHeading id="bonuses-title" title={<>
              Und dazu erhältst du <span className="italic text-coral" data-id="element-25" data-mp="5wrx6lp4z0ki">5 exklusive Bonusmaterialien</span>
            </>} intro="Materialien, die dir helfen, über das bloße Verteilen einer Karte hinauszugehen und den Missionsbefehl noch bewusster zu leben." data-id="element-24" data-mp="1u58uurobxs2" />
        <ol className="mx-auto mt-16 grid max-w-5xl grid-cols-1 gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-6" data-id="element-26" data-mp="1mai4007n42xu">
          {bonuses.map((b, i) => <li key={b.number} className={`flex flex-col lg:col-span-2 ${placement[i]}`} data-id="element-27" data-mp="1r8temd5rehh4" data-mpi={i}>
              <div className="relative mx-auto w-full max-w-[280px]" data-id="element-28" data-mp="3icvddfc7wq3i">
                <span className="absolute -left-3 -top-3 z-10 rounded-full bg-navy px-3 py-1.5 text-xs font-extrabold uppercase tracking-[0.1em] text-white shadow-card" data-id="element-29" data-mp="3dg4z8xjz44kq">
                  Bonus {b.number}
                </span>
                <BonusCover bonus={b} data-id="element-30" data-mp="3n5oja6jfa4h6" />
              </div>
              <div className="mx-auto mt-6 flex max-w-[300px] flex-1 flex-col text-center" data-id="element-31" data-mp="2zf29a9puya4j">
                <h3 className="hyphens-auto font-display text-[22px] leading-tight text-navy sm:text-2xl" style={{
              fontSize: "20px"
            }} data-id="element-32" data-mp="2ugr103f7o7of">{b.name}</h3>
                <p className="mt-3 font-bold leading-snug text-coral-deep" data-id="element-33" data-mp="38htn2g67hhzc">{b.lead}</p>
                <p className="mt-2 text-[15px] leading-relaxed text-ink-soft" data-id="element-34" data-mp="33ge3ksjofjj2">{b.body}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}